import { isNullOrUndefined, reduce } from "et3-type-guards";

import configuration from "../configuration/keys";
import { TUserMessagesObject } from "../Types";

export const parseConversationData = (
  data: {
    messageId: number;
    senderId: number;
    recipientId: number;
    message: string;
    sentOn: string;
    messageType: string;
  }[]
) => {
  const editedData: TUserMessagesObject[] = data.map((item, index) => {
    return {
      id: index,
      ...item,
      messageObject: {
        message: item.message,
        messageType: item.messageType
      },
      userMessagesRecipientId: {
        senderId: item.senderId,
        recipientId: item.recipientId
      }
    };
  });
  for (let i = editedData.length - 1; i >= 0; i--) {
    const type = reduce(() => editedData[i].messageObject.messageType, "");
    const message = reduce(() => editedData[i].messageObject.message, "");
    if (type === "voice") {
      const validString = message.replace(/[\u201C\u201D]/g, '"');
      const messageObject = JSON.parse(validString);
      const voiceUrl = `${configuration.voiceAttachmentUrl}${messageObject.attachment}`;
      editedData[i].messageObject.message = voiceUrl;
    } else if (type === "picture") {
      const validString = message.replace(/[\u201C\u201D]/g, '"');
      const messageObject = JSON.parse(validString);
      const imageUrl = `${configuration.imageAttachmentUrl}${messageObject.attachment}`;
      editedData[i].messageObject.message = imageUrl;
    }
  }
  return editedData;
};

export const getUniqueConversationData = ({
  data,
  uniqueBy
}: {
  data: {
    messageId: number;
    senderId: number;
    recipientId: number;
    messageObject: {
      message: string;
      messageType: string;
    };

    sentOn: string;
  }[];
  uniqueBy: "messageId";
}) => {
  if (isNullOrUndefined(data)) {
    return [];
  }
  const uniqueData = data
    .filter((v, i, a) => a.findIndex((t) => t[uniqueBy] === v[uniqueBy]) === i)
    .map((item, index) => {
      return {
        id: index,
        messageId: item.messageId,
        senderId: item.senderId,
        recipientId: item.recipientId,
        userMessagesRecipientId: {
          senderId: item.senderId,
          recipientId: item.recipientId
        },
        messageObject: item.messageObject,
        sentOn: item.sentOn
      };
    });
  return uniqueData;
};

export const khattabaConversationParsing = (text: string) => {
  const parsedText = text.replace(/["']/g, (char: string) => {
    switch (char) {
      case '"':
        return "“";
      case "'":
        return "‘";
      case "\n":
        return "";
      default:
        return "";
    }
  });
  return parsedText;
};

export const parseEscapedNewlines = (str: string) => {
  return str.replace(/\\n/g, "\n");
};

export const getAttachmentName = (message: string) =>
  JSON.parse(message.replace(/[“”]/g, '"')).attachment;
